import React from "react";
import { useForm } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import { Typography, Button, CssBaseline, Grid, Container, MenuItem } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { USER_ROLES } from "../../constants/constants";
import SelectInput from "../ui_components/select_input";
import TextInput from "../ui_components/text_input";
import { addUser } from "../../store/actions/user/user_action";
import { useSnackbar } from "notistack";

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(8),
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main
    },
    form: {
        width: "100%", // Fix IE 11 issue.
        marginTop: theme.spacing(1),
        "& > p": {
            color: "#bf1650",
            "&::before": {
                display: "inline",
                content: '"⚠ "'
            }
        }
    },
    submit: {
        margin: theme.spacing(3, 0, 2)
    },
    link: {
        color: "#64b5f6",
        "&:hover": {
            color: "#53a3df"
        }
    }
}));

const AddUser = () => {
    const { paper, form, submit } = useStyles();
    const {
        control,
        handleSubmit,
        formState: { errors }
    } = useForm();
    const { enqueueSnackbar } = useSnackbar();

    const onSubmit = async (data) => {
        const { message } = await addUser(data);
        if (message) {
            return enqueueSnackbar(message, {
                variant: "warning"
            });
        }
        enqueueSnackbar("Uspešno ste dodali korisnika", {
            variant: "success"
        });
        return history.push(REACT_ROUTES.HOME);
    };

    return (
        <Container component="main" maxWidth="xs">
            <CssBaseline />
            <Grid className={paper}>
                <Typography component="h1" variant="h5">
                    Dodajte novog korisnika
                </Typography>
                <form onSubmit={handleSubmit(onSubmit)} className={form}>
                    <TextInput name="firstName" label="Ime" control={control} rules={{ required: "Unesite ime novog korisnika" }} />
                    <ErrorMessage errors={errors} name="firstName" as="p" />
                    <TextInput name="lastName" label="Prezime" control={control} rules={{ required: "Unesite prezime novog korisnika" }} />
                    <ErrorMessage errors={errors} name="lastName" as="p" />
                    <TextInput name="email" label="Email" control={control} rules={{ required: "Unesite email novog korisnika" }} />
                    <ErrorMessage errors={errors} name="email" as="p" />
                    <SelectInput
                        name="roles"
                        label="Uloge"
                        control={control}
                        rules={{ required: "Unesite uloge novog korisnika" }}
                        multiple
                    >
                        {USER_ROLES.map((role, index) => (
                            <MenuItem key={index} value={role.value}>
                                {role.label}
                            </MenuItem>
                        ))}
                    </SelectInput>
                    <ErrorMessage errors={errors} name="roles" as="p" />
                    <Button type="submit" variant="contained" color="primary" className={submit} fullWidth>
                        Dodajte korisnika
                    </Button>
                </form>
            </Grid>
        </Container>
    );
};

export default AddUser;
